import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Preloader() {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDone(true), 2200);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence onExitComplete={() => window.dispatchEvent(new Event("preloader-done"))}>
      {!done && (
        <motion.div
          className="fixed inset-0 z-[10000] bg-[#050505] flex items-center justify-center"
          exit={{ y: "-100%" }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
          data-testid="preloader"
        >
          <div className="text-center">
            <motion.div
              initial={{ opacity: 0, letterSpacing: "0.1em" }}
              animate={{ opacity: 1, letterSpacing: "0.4em" }}
              transition={{ duration: 1.6, ease: "easeOut" }}
              className="font-display text-2xl sm:text-4xl gold-fill"
            >
              CROWN ARTISAN
            </motion.div>
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.8, ease: "easeInOut" }}
              className="gold-line mt-6 w-56 sm:w-72 mx-auto origin-left"
            />
            <motion.div
              initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.6, duration: 1 }}
              className="overline mt-6"
            >
              Crafting the Extraordinary
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
